import { FC } from "react"
import { useTranslation } from "react-i18next"
import { HomeBgImg, LogoBigImg } from "@/assets"
import { useAppDispatch } from "@/store"
import { setReAuthState } from "@/store/slices/app"
import { Button } from "@/ui/Button"
import styles from "./TelegramAuthError.module.scss"

export const TelegramAuthError: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleRetry = () => {
    dispatch(setReAuthState("loading"))
  }

  return (
    <div className={styles.TelegramAuthError}>
      <img
        src={HomeBgImg}
        alt="background"
        className={styles.TelegramAuthError_bg}
      />
      <img
        src={LogoBigImg}
        alt="logo"
        className={styles.TelegramAuthError_logo}
      />
      <p className={styles.TelegramAuthError_text}>{t("errors.authFailed")}</p>
      <Button className={styles.TelegramAuthError_button} onClick={handleRetry}>
        {t("button.retry")}
      </Button>
    </div>
  )
}
